import { useAsync } from 'core/ui/hooks/useAsync'

import { refreshToken as refreshTokenUseCase } from '../use-cases/refreshToken'

export function useRefreshToken() {
  const { call: refreshToken, result, status } = useAsync(refreshTokenUseCase)

  return { emailRecipient: result, refreshTokenStatus: status, refreshToken }
}
